export default "__VITE_ASSET__D1IgNw3___"